import { render } from "./Otz.vue?vue&type=template&id=ec85c194&scoped=true"
import script from "./Otz.vue?vue&type=script&lang=js"
export * from "./Otz.vue?vue&type=script&lang=js"

import "./Otz.vue?vue&type=style&index=0&id=ec85c194&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec85c194"]])

export default __exports__